export const ENTER_KEY = 'Enter';
export const viewMode = {
  DIALOG: 'dialog',
  CONTENT: 'content',
};

export const extraPrices = {
  FREE_COM_DOMAIN: 'free_com_domain',
  NO_DISCOUNTS: 'no_discounts',
  ANNUAL_TRIAL_PACKAGE: 'annual_trial_package',
};

export const mockedDomainsData = [
  { domain: 'example.com', available: true },
  { domain: 'example.org', available: true },
  { domain: 'example.net', available: true },
  { domain: 'example.eu', available: true },
  { domain: 'example.ua', available: true },
  { domain: 'example.bar', available: true },
  { domain: 'example.de', available: true },
  { domain: 'example.it', available: true },
  { domain: 'example.co', available: true },
  { domain: 'example.shop', available: true },
];
